import { render, staticRenderFns } from "./physiologySprint.vue?vue&type=template&id=b6a20f6e&"
import script from "./physiologySprint.js?vue&type=script&lang=js&"
export * from "./physiologySprint.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports